import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Switch, FormControlLabel, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import GanttChartComponent from './GanttChartComponent';
import TimelinePopupComponent from './TimelinePopupComponent';

const TimelinePopup = ({ dialogOpen, handleDialogClose, projectId }) => {
  const [showGanttChart, setShowGanttChart] = useState(false);

  const handleDialogCloseWithReset = () => {
    handleDialogClose();
  };

  const handleSwitchChange = (event) => {
    setShowGanttChart(event.target.checked);
  };

  return (
    <Dialog open={dialogOpen} onClose={handleDialogCloseWithReset} maxWidth="lg" fullWidth>
      <DialogTitle>
        Project Timeline
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <FormControlLabel
            control={<Switch checked={showGanttChart} onChange={handleSwitchChange} />}
            label="Schedule Chart"
          />
          <Button
            aria-label="close"
            onClick={handleDialogCloseWithReset}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </Button>
        </Box>
      </DialogTitle>
      <DialogContent>
        {showGanttChart ? (
          <GanttChartComponent projectId={projectId} />
        ) : (
          <TimelinePopupComponent projectId={projectId} />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDialogCloseWithReset} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TimelinePopup;